export const CurrentVersion = process.env.REACT_APP_CURRENT_VERSION